import { useEffect, useRef } from 'react';

export function useInterval (callback, delay, immediate) {
	const savedCallback = useRef();

	// Remember the latest callback.
	useEffect(() => {
		savedCallback.current = callback;
	}, [callback]);

	// Set up the interval.
	useEffect(() => {
		function tick () {
			savedCallback.current();
		}

		if (immediate) {
			tick();
		}

		if (delay !== null) {
			const id = setInterval(tick, delay);
			return () => clearInterval(id);
		}
	}, [delay, immediate]);
}

